import React from 'react';

const WarningIcon = ({ width = 40, height = 40, color = '#C22702' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 41 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.5 3.41666C11.07 3.41666 3.41663 11.07 3.41663 20.5C3.41663 29.93 11.07 37.5833 20.5 37.5833C29.93 37.5833 37.5833 29.93 37.5833 20.5C37.5833 11.07 29.93 3.41666 20.5 3.41666ZM22.2083 29.0417H18.7916V25.625H22.2083V29.0417ZM22.2083 22.2083H18.7916V11.9583H22.2083V22.2083Z"
      fill={color}
    />
  </svg>
);

export default WarningIcon;
